module.exports = __webpack_public_path__ + "static/img/car_coin_renting.9.61002c0a.png";